<template>
<div class="chapter">
<div class="inner_page">
<p class="txb" style="margin-top: 5em;">Perhaps if she curls up very small, she won’t hurt anyone ever again.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781569479674_Split6.vue?4993986b